"use strict";
exports.__esModule = true;
var Chart_1 = require("../entity/Chart");
var createLabels_1 = require("../utility/createLabels");
var createRows_1 = require("../utility/createRows");
var createMockData = function (from, to) {
    return {
        charts: [
            {
                id: '1',
                header: {
                    dimensions: [
                        { breakdown: 'device', filter: [] },
                        { breakdown: 'device', filter: [] },
                    ],
                    scope: {
                        from: from.toFormat('yyyy/MM/dd'),
                        to: to.toFormat('yyyy/MM/dd'),
                        frequency: 'DAILY'
                    }
                },
                columns: (0, createLabels_1["default"])('DAILY', from, to),
                datasets: [
                    {
                        id: '99',
                        type: 'LINE',
                        label: 'CVリフト (desktop x 31304)',
                        rows: (0, createRows_1["default"])('DAILY', from, to, true),
                        position: 'RIGHT',
                        percentage: true
                    },
                    {
                        id: '99',
                        type: 'BAR',
                        label: 'CVリフト (sp x 31304)',
                        rows: (0, createRows_1["default"])('DAILY', from, to)
                    },
                    {
                        id: '99',
                        type: 'BAR',
                        label: 'CVリフト (pc x 31304)',
                        rows: (0, createRows_1["default"])('DAILY', from, to)
                    },
                    {
                        id: '100',
                        type: 'BAR',
                        label: 'CVリフト（積み上げ） (desktop x 31304)',
                        rows: (0, createRows_1["default"])('DAILY', from, to)
                    },
                    {
                        id: '100',
                        type: 'BAR',
                        label: 'CVリフト（積み上げ） (sp x 31304)',
                        rows: (0, createRows_1["default"])('DAILY', from, to)
                    },
                    {
                        id: '100',
                        type: 'LINE',
                        label: 'CVリフト（積み上げ） (pc x 31304)',
                        rows: (0, createRows_1["default"])('DAILY', from, to)
                    },
                    {
                        id: '100',
                        type: 'BAR',
                        label: 'CVリフト（積み上げ） (undefined x 31304)',
                        rows: (0, createRows_1["default"])('DAILY', from, to)
                    },
                ],
                dimensions: [
                    {
                        key: {
                            label: 'デバイス',
                            value: 'device'
                        },
                        values: ['PC', 'SP', 'Tablet', 'undefined'],
                        filterRequired: false,
                        display: true
                    },
                    {
                        key: {
                            label: '流入',
                            value: 'channel'
                        },
                        values: ['Search', 'Ad'],
                        filterRequired: false,
                        display: true
                    },
                ],
                frequencies: ['DAILY', 'WEEKLY', 'MONTHLY'],
                originalDatasets: [
                    { id: '99', type: 'LINE', label: 'CVリフト' },
                    { id: '100', type: 'BAR', label: 'CVリフト（積み上げ）' },
                ]
            },
            {
                id: '1',
                header: {
                    scope: {
                        from: from.toFormat('yyyy/MM/dd'),
                        to: to.toFormat('yyyy/MM/dd'),
                        frequency: 'WEEKLY'
                    }
                },
                columns: (0, createLabels_1["default"])('WEEKLY', from, to),
                datasets: [
                    {
                        id: 'hoge',
                        type: 'LINE',
                        label: 'A',
                        rows: (0, createRows_1["default"])('WEEKLY', from, to),
                        position: 'LEFT'
                    },
                    {
                        id: 'hoge',
                        type: 'BAR',
                        label: 'B',
                        rows: (0, createRows_1["default"])('WEEKLY', from, to)
                    },
                    {
                        id: 'hoge',
                        type: 'BAR',
                        label: 'C',
                        rows: (0, createRows_1["default"])('WEEKLY', from, to)
                    },
                ],
                dimensions: [
                    {
                        key: {
                            label: 'デバイス',
                            value: 'device'
                        },
                        values: ['PC', 'SP', 'Tablet', 'undefined'],
                        filterRequired: false,
                        display: true
                    },
                    {
                        key: {
                            label: '流入',
                            value: 'channel'
                        },
                        values: ['Search', 'Ad'],
                        filterRequired: false,
                        display: true
                    },
                ],
                frequencies: ['DAILY', 'WEEKLY', 'MONTHLY']
            },
            {
                id: '1',
                header: {
                    scope: {
                        from: from.toFormat('yyyy/MM/dd'),
                        to: to.toFormat('yyyy/MM/dd'),
                        frequency: 'MONTHLY'
                    }
                },
                columns: (0, createLabels_1["default"])('MONTHLY', from, to),
                datasets: [
                    {
                        id: 'hoge',
                        type: 'LINE',
                        label: 'A',
                        rows: (0, createRows_1["default"])('MONTHLY', from, to)
                    },
                    {
                        id: 'hoge',
                        type: 'BAR',
                        label: 'B',
                        rows: (0, createRows_1["default"])('MONTHLY', from, to)
                    },
                    {
                        id: 'hoge',
                        type: 'BAR',
                        label: 'C',
                        rows: (0, createRows_1["default"])('MONTHLY', from, to)
                    },
                ],
                dimensions: [
                    {
                        key: {
                            label: 'デバイス',
                            value: 'device'
                        },
                        values: ['PC', 'SP', 'Tablet', 'undefined'],
                        filterRequired: false,
                        display: true
                    },
                    {
                        key: {
                            label: '流入',
                            value: 'channel'
                        },
                        values: ['Search', 'Ad'],
                        filterRequired: false,
                        display: true
                    },
                ],
                frequencies: ['DAILY', 'WEEKLY', 'MONTHLY']
            },
        ]
    }.charts.map(function (data) { return Chart_1["default"].fromJSON(data); });
};
exports["default"] = createMockData;
